import React from 'react';
import {useState, useEffect, useRef} from "react";
import { Link } from 'react-router-dom';
import './Distributors.css';
import useAxiosPrivate from "../../context/useAxiosPrivate";
import {DataTable} from "../data-table/DataTable";
import {RefreshTimer} from "./RefreshTimer";
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import { Select, MenuItem } from '@mui/material'
import {useAuth} from "../../context/useAuth";
import { baseUrl } from "../../api/axios";
import '../data-table/DataTable.css';


export const Distributors = ({userRole}) => {
  const { auth, setAuth } = useAuth();
  const [version, setVersion] = useState(null);
  const [factories, setFactories] = useState(null);
  const refFactories = useRef({previousFactoriesLength: 0, currentFactoriesLength: 0})
  const [companies, setCompanies] = useState(null);
  const [usersByFactoryId, setUsersByFactoryId] = useState([]);
  const [currentFactory, setCurrentFactory] = useState('');
  const [currentFactoryData, setCurrentFactoryData] = useState(null)
  const [modalType, setModalType] = useState('');
  const [isAdditionalOpen, setIsAdditionalOpen] = useState(false);
  const axiosPrivate = useAxiosPrivate();

  const [factoriesSelectOptions, setFactoriesSelectOptions] = useState('');

  const [isRefreshing, setIsRefreshing] = useState(false);
  const [isFactorySwitching, setIsFactorySwitching] = useState(false); // Новое состояние для переключения заводов
  const refreshIntervalRef = useRef(null);

  useEffect(() => {
    if (userRole.roleId === 1) {
      getFactories();
      getCompanies();
      // getVersion();
    } else {
      getCompanies();
      setCurrentFactory(userRole.id);
      // getVersion();
    }
  },[]);


      useEffect(() => {
    if (currentFactory !== '') {
      setIsFactorySwitching(true); // Начинаем загрузку при переключении завода
      
      const fetchData = async () => {
        try {
          await getUsersByFactoryId();
          if (userRole.roleId === 1) {
            await Promise.all([
              getCurrentFactoryData(),
              getVersion(currentFactory)
            ]);
          }
        } catch (error) {
          console.log("Error switching factory:", error);
        } finally {
          setIsFactorySwitching(false); // Заканчиваем загрузку после получения данных
        }
      };
      
      fetchData();
      localStorage.setItem('chosenFactory', currentFactory);
    }
  }, [currentFactory]);

  useEffect(() => {
    if (refreshIntervalRef.current) {
      clearInterval(refreshIntervalRef.current);
    }

    refreshIntervalRef.current = setInterval(() => {
      // При открытом модальном окне (добавление/редактирование и т.п.) автообновление приостанавливаем
      if (modalType === '') {
        refreshAllData();
      }
    }, 180000);

    return () => {
      if (refreshIntervalRef.current) {
        clearInterval(refreshIntervalRef.current);
      }
    };
  }, [currentFactory, userRole.roleId, modalType]);


  const getVersion = async (factoryId) => {
    await axiosPrivate.get(`Users/Version/${factoryId}`)
      .then((res) => {
        setVersion(res.data)
      })
      .catch( (e) => { console.log("getVersion error ", e) } );
  }

  const getFactories = async () => {
    await axiosPrivate.get('/Users/Factory')
      .then((res) => {
        setFactories(res.data);
        refFactories.current.currentFactoriesLength = res.data.length;
      })
      .catch( (e) => { console.log("getFactories error ", e) } );
  }


  const getCompanies = async () => {
    await axiosPrivate.get('/Users/Company')
      .then((res) => {
        setCompanies(res.data);
      })
      .catch( (e) => { console.log("getCompanies error ", e) } );
  }

  const getUsersByFactoryId = async () => {
    await axiosPrivate.get(`/Users/GetByFactory/${currentFactory}`)
      .then((res) => {
        setUsersByFactoryId(res.data)
      })
      .catch( (e) => { console.log("getUsersByFactoryId error ", e) } );
  }

  const refreshAllData = async () => {
    setIsRefreshing(true);
    try {
      if (userRole.roleId === 1) {
        await Promise.all([
          getFactories(),
          getCompanies(),
          currentFactory && getVersion(currentFactory)
        ]);
      } else {
        await getCompanies();
      }
      if (currentFactory) {
        await getUsersByFactoryId();
      }
    } catch (error) {
      console.log("Refresh error:", error);
    } finally {
      setIsRefreshing(false);
    }
  }


  useEffect(() => {
    if (factories !== null) {
      getFactoriesSelectOptions()
    }

  }, [factories]);

  const getCurrentFactoryData = () => {
    setCurrentFactoryData(factories.filter((factory) => {
      return factory.id === parseInt(currentFactory)
    }))
  }

  const getFactoriesSelectOptions = () => {
    const optionData = factories.map((factory) => {
      return <MenuItem key={factory.id} value={factory.id}>{`${factory.factory}`}</MenuItem>
    })
    setFactoriesSelectOptions(optionData); // form list of factories in dropdown menu

    const savedFactoryId = JSON.parse(localStorage.getItem('chosenFactory'))
    const savedIdIsExist = factories.some((item) => {
      return item.id === savedFactoryId
    })


    if (userRole.roleId === 1 && JSON.parse(localStorage.getItem('chosenFactory')) === null) {
      setCurrentFactory(factories[0].id)
    }

    if (savedIdIsExist && userRole.roleId === 1 && JSON.parse(localStorage.getItem('chosenFactory')) !== null) {
      setCurrentFactory(JSON.parse(localStorage.getItem('chosenFactory')));
    } else {
      setCurrentFactory(factories[0].id)
    }
    // if (currentFactory === '') {
    //   setCurrentFactory('2')
    // }

    userRole.roleId === 1 && getCurrentFactoryData();
  }




  return (
    <div className="distributors-container">
      <div className="distributors-controls">
        <ul className="distributors-controls__list">
          <li className="distributors-controls__item">
            <div className={userRole.roleId === 1 ? "distributors-factories" : "hidden"}>
              <label className="distributors-button-label">
                Активность заводов
                <button
                  className="factory-button"
                  onClick={() => setModalType("factoryActivity")}
                ></button>
              </label>


              <div className="distributors-factories-controls">
                                <div className="select-container" style={{position: "relative"}}>
                                    {isFactorySwitching && (
                    <div 
                      className="factory-loading-indicator"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(255, 255, 255, 0.8)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1,
                        borderRadius: "8px",
                        fontSize: "1.2vw",
                        color: "#3cb7ff"
                      }}
                    >
                      Загрузка...
                    </div>
                  )}
                  {userRole.roleId === 1 && <Select
                    IconComponent={ExpandMoreOutlinedIcon}
                    style={{backgroundColor: "white", position: "relative"}}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      PaperProps: {
                        sx: {
                          '& .MuiMenuItem-root': {fontSize: "1.5vw"}
                        }
                      }
                    }}
                    sx={{
                      '& .MuiInputBase-root': {borderRadius: "8px", border: "0.2vw solid grey", outline: "none", position: "relative"},
                      '& .MuiSelect-select': {
                        backgroundColor: "white",
                        border: "none",
                        width: "100%",
                        fontSize: "1.5vw",
                        minHeight: "2vw",
                        lineHeight: "1",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        overflow: "hidden",
                        position: "relative",
                      },
                      '& .MuiInputBase-input': {padding: "0 3vw 0 0.5vw !important"},
                      '& .MuiSvgIcon-root': {position: "absolute", top: "calc(50% - 1.5vw)", right: "0", display: "flex", justifyContent: "center", alignItems: "center", fontSize: "3vw", backgroundColor: "transparent"},

                    }}
                    variant={"outlined"}
                    autoWidth={true}
                    value={currentFactory}
                    onChange={(event) => {
                      setCurrentFactory(event.target.value);
                    }
                    }
                    disabled={isFactorySwitching}
                  >
                    {factoriesSelectOptions}
                  </Select>}
                </div>


                <button className="distributors-button distributors-button__add distributors-button__add_factory"
                        onClick={() => setModalType('addFactory')}
                >+</button>

                <button className="distributors-button distributors-button__add distributors-button__edit"
                        onClick={() => setModalType('editFactory')}
                ></button>
              </div>

            </div>
          </li>


          <li className="distributors-controls__item">

          </li>

          {userRole.roleId === 1 && version && <li className="distributors-controls__item">
            <a className="distributors-version platform platform__android platform_position" target="_blank" href={`${version.linkAndroid}`}></a>

            <a className="distributors-version platform platform__ios platform_position" target="_blank" href={`${version.linkIOS}`}></a>

            <a className="distributors-version platform platform__macos platform_position" target="_blank" href={`${version.linkMacOS}`}></a>
          </li>}

          {userRole.roleId === 1 && version && <li className="distributors-controls__item">
               <a className="distributors-version" download={`${version.factoryName}`} href={`${baseUrl}${version.link}`}>{version.version}</a>
          </li>}

          <li className="distributors-controls__item">
            <RefreshTimer isRefreshing={isRefreshing} />
          </li>

          <li className="distributors-controls__item">
            <button className="distributors-button__logout" onClick={() => {
              localStorage.setItem('currentVisitorFAPP', null)
              setAuth(null)
            }}></button>
          </li>
        </ul>

        <div className="distributors-edit-container">
          <div className={userRole.roleId === 1 ? "distributors-edit" : "hidden"}>
            <label className="distributors-button-label">Добавить компанию
              <button id="add-company" className="distributors-button distributors-button__add"
              onClick={() => setModalType('addCompany')}
              >+</button>
            </label>

            <label
              style={usersByFactoryId.length === 0 ? {display: "none"} : {}}
              className="distributors-button-label">Добавить компьютер в имеющуюся компанию
              <button
                disabled={(usersByFactoryId.length === 0) && true}
                className="distributors-button distributors-button__add"
              onClick={() => setModalType('addUser')}
              >+</button>
            </label>
          </div>

          <div className="distributors-additional">
            <label className="distributors-button-label">
              Дополнительно
              <button
                className="distributors-more-button"
                onClick={() => setIsAdditionalOpen((prev) => !prev)}
              >
                <MenuIcon />
              </button>
            </label>
            {isAdditionalOpen && (
              <div className="distributors-additional-menu">
                <button
                  className="distributors-button distributors-button__secondary"
                  onClick={() => {
                    setModalType("factoryNotify");
                    setIsAdditionalOpen(false);
                  }}
                >
                  Отправить уведомление
                </button>
                <Link to="/delete-versions">
                  <button
                    className="distributors-button distributors-button__secondary"
                    onClick={() => setIsAdditionalOpen(false)}
                  >
                    Удаление версий
                  </button>
                </Link>
              </div>
            )}
          </div>

          {userRole.roleId === 1 && <label className="distributors-button-label">
            Конфигуратор
            <Link to="/add-json">
              <button className="settings-button"></button>
            </Link>
          </label>
          }
        </div>
      </div>

            <DataTable
        getFactories={getFactories}
        factories={factories}
        currentFactoryData={currentFactoryData}
        usersByFactoryId={usersByFactoryId}
        setUsersByFactoryId={setUsersByFactoryId}
        getUsersByFactoryId={getUsersByFactoryId}
        getCompanies={getCompanies}
        userRole={userRole}
        modalType={modalType}
        setModalType={setModalType}
        companies={companies}
        currentFactory={currentFactory}
        setCurrentFactory={setCurrentFactory}
        isFactorySwitching={isFactorySwitching} // Передаем состояние загрузки при переключении заводов
      />
    </div>
  )
}